import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { Wrapper } from './Wrapper';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { useTasks } from '@poplar/contexts/TaskContext/TaskProvider';
import { useTranslation } from '@yoweb/next-i18next';
import { uploadIntakeFiles } from '@poplar/components/Questions/intake-form/utils';
import { useUser } from '@poplar/hooks/useUser';
import { TodoEditType } from '@poplar/types/enums';
import { jsx as _jsx } from "react/jsx-runtime";
export var TemplatedEdit = function TemplatedEdit(_ref) {
  var onSlideClose = _ref.onSlideClose,
      initialTask = _ref.initialTask,
      initialError = _ref.initialError,
      onDirtyChange = _ref.onDirtyChange,
      todoEditType = _ref.todoEditType,
      isSubscriptionFlow = _ref.isSubscriptionFlow;

  var _useToast = useToast(),
      showToastMessage = _useToast.showToastMessage;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useTasks = useTasks(),
      handoffTaskAction = _useTasks.actions.handoffTask;

  var _useUser = useUser(),
      watchSafeFetch = _useUser.actions.watchSafeFetch;

  var _useState = useState(initialError),
      error = _useState[0],
      setError = _useState[1]; // Controls whether the user can navigate back or exit the flyout. Disable both buttons when saving/handoff


  var _useState2 = useState(true),
      allowNavigation = _useState2[0],
      setAllowNavigation = _useState2[1];

  var onSaveDraft = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(questionsList, saveTask, onSubmitSuccess) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setAllowNavigation(false);
              _context.next = 4;
              return uploadIntakeFiles(questionsList, watchSafeFetch);

            case 4:
              _context.next = 6;
              return saveTask({
                taskId: initialTask.taskId,
                questionsList: questionsList
              });

            case 6:
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              setError(_context.t0);
              throw _context.t0;

            case 12:
              _context.prev = 12;
              setAllowNavigation(true);
              return _context.finish(12);

            case 15:
              onSlideClose(true);
              showToastMessage({
                message: t(todoEditType === TodoEditType.TODO_EDIT_RECURRING_QUESTION ? 'toasts.updated' : 'task-draft-saved', {
                  ns: todoEditType === TodoEditType.TODO_EDIT_RECURRING_QUESTION ? 'tasks' : 'common'
                })
              });
              onSubmitSuccess();

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8, 12, 15]]);
    }));

    return function onSaveDraft(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var onHandOff = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(questionsList, saveTask, onSubmitSuccess) {
      var savedTask;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              setAllowNavigation(false);
              _context2.next = 4;
              return uploadIntakeFiles(questionsList, watchSafeFetch);

            case 4:
              _context2.next = 6;
              return saveTask({
                taskId: initialTask.taskId,
                questionsList: questionsList
              });

            case 6:
              savedTask = _context2.sent;
              _context2.next = 9;
              return handoffTaskAction(savedTask, {
                onSuccess: function onSuccess() {
                  onSlideClose(true);
                  onSubmitSuccess();
                }
              });

            case 9:
              _context2.next = 15;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              setError(_context2.t0);
              throw _context2.t0;

            case 15:
              _context2.prev = 15;
              setAllowNavigation(true);
              return _context2.finish(15);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 11, 15, 18]]);
    }));

    return function onHandOff(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx(Wrapper, {
    questionsList: initialTask.questionsList,
    title: initialTask.name,
    description: initialTask.description,
    error: error,
    onSlideClose: onSlideClose,
    onHandOff: onHandOff,
    onSaveDraft: onSaveDraft,
    initialTask: initialTask,
    onDirtyChange: onDirtyChange,
    allowNavigation: allowNavigation,
    taskTemplateId: initialTask.taskIntakeTemplateId,
    todoEditType: todoEditType,
    isSubscriptionFlow: isSubscriptionFlow
  });
};